{
  "validation.required": "{{label}} est un champ obligatoire",
  "validation.minLength": "{{label}} doit comporter au moins {{min}} caractères",
  "validation.maxLength": "{{label}} ne peut pas dépasser {{max}} caractères",
  "validation.contentTypeAlphanumeric": "{{label}} doit être alphanumérique",
  "validation.contentTypeDate": "{{label}} doit être une date",
  "validation.contentTypeDateBefore": "{{label}} doit être une date antérieure à {{date beforeDate}}",
  "validation.contentTypeDateAfter": "{{label}} doit être une date après {{date afterDate}}",
  "validation.contentTypeDatetime": "{{label}} doit être une date et une heure",
  "validation.contentTypeDatetimeBefore": "{{label}} doit être une date antérieure à {{datetime beforeDate}}",
  "validation.contentTypeDatetimeAfter": "{{label}} doit être une date après {{datetime afterDate}}",
  "validation.contentTypeEmail": "{{label}} doit être un email",
  "validation.contentTypeInteger": "{{label}} doit être un nombre",
  "validation.contentTypeNumber": "{{label}} doit être un nombre",
  "validation.contentTypeRegex": "{{label}} a le mauvais format",
  "validation.contentTypeText": "{{label}} doit être un texte",
  "validation.contentTypeTime": "{{label}} doit être une heure",
  "validation.contentTypeUrl": "{{label}} doit être une adresse Web",
  "select-element.default-option": "Sélectionner…",
  "button-element.network-required": "Vous êtes actuellement hors ligne. Veuillez établir une connexion réseau pour continuer."
}